module.exports = __webpack_public_path__ + "img/JustText_Colour.71526d13.svg";